import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

const LineChartGraph = ({ selectOption, graphData = [] }) => {
  const [dataList, setDataList] = useState([])
  const [labelList, setLabelList] = useState([])

  const [mediaResult, setMediaResult] = useState(null) // true: mobile
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const matchQueryList = window.matchMedia('all and (max-width: 768px)')
      setMediaResult(matchQueryList.matches)

      const media = function handleChange(e) {
        setMediaResult(e.matches)
      }

      matchQueryList.addEventListener('change', media)
    }
  }, [])

  useEffect(() => {
    if (graphData?.length > 0) {
      setLabelList(graphData.map((item) => item.date))
      switch (selectOption.category) {
        case 'sales': // 매출금액
          setDataList(graphData.map((item) => item.total_sales_amount))
          break
        case 'count': // 판매건수
          setDataList(graphData.map((item) => item.total_purchases_num))
          break
        case 'average': // 객단가
          setDataList(graphData.map((item) => item.unit_price_avg))
          break
        case 'total_visitor': // 방문자수
          setDataList(graphData.map((item) => item.total_visitor_num))
          break
        case 'new_user': // 신규회원
          setDataList(graphData.map((item) => item.new_user_num))
          break
        case 'old_user': // 기존회원
          setDataList(graphData.map((item) => item.old_user_num))
          break
        default:
          setDataList(graphData.map((item) => item.total_sales_amount))
          break
      }
    }
  }, [selectOption, graphData])

  const options = {
    responsive: true,
    aspectRatio: mediaResult ? 1 : 3.5,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (item) => {
            return item.formattedValue + selectOption.unit
          },
        },
      },
    },
    tension: 0.1,
    scales: {
      y: {
        ticks: {
          callback: function (val, index) {
            return index === 0
              ? this.getLabelForValue(val) + ` (${selectOption.unit})`
              : this.getLabelForValue(val)
          },
          color: '#117ffa',
        },
      },
      x: {
        ticks: {
          callback: function (val, index) {
            // return index === 0
            // 	? this.getLabelForValue(val) + ` (${selectOption.unit})`
            // 	: this.getLabelForValue(val);
            // return moment(this.getLabelForValue(val)).format("YYYY.MM.DD");
            return this.getLabelForValue(val)
          },
          color: '#868e96',
        },
      },
    },
  }

  const data = {
    labels: labelList,
    datasets: [
      {
        label: selectOption.category_name,
        data: dataList,
        borderColor: 'rgb(17,127,250)',
        backgroundColor: 'rgba(17,127,250, 0.5)',
      },
    ],
  }

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <Line options={options} data={data} />
    </div>
  )
}

export default LineChartGraph
